<!--todo make as single base component-->

<template>
    <div class="withdrawal-page">
        <BasePageTitle :title="tokens.notifications.withdrawal"/>
        <p v-if="!availableWithdrawalMethods.length || !user.enable_withdrawal" class="desc title__small">
            {{ 'No available withdrawal methods. Please contact your manager.' }}
        </p>
        <p v-else class="desc title__small">{{ tokens.newDesign.selectWithdrawalMethod }}</p>
        <BaseTabsBox v-if="availableWithdrawalMethods.length">
            <template #content>
                <div v-for="method in availableWithdrawalMethods" :key="method.name" class="tab">
                    <BaseTabBox v-if="method.name === 'card'" :tab="method.name"
                                :class="{ active: active.key === method.name }" @click.native="changeTab(method.name)">
                        <template #icon>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32"
                                 fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M12.8334 21.3333C12.8334 20.781 13.2811 20.3333 13.8334 20.3333H15.8334C16.3856 20.3333 16.8334 20.781 16.8334 21.3333C16.8334 21.8855 16.3856 22.3333 15.8334 22.3333H13.8334C13.2811 22.3333 12.8334 21.8855 12.8334 21.3333Z"
                                      fill="#AFC6FF"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M18.8334 21.3333C18.8334 20.781 19.2811 20.3333 19.8334 20.3333H24.5C25.0523 20.3333 25.5 20.781 25.5 21.3333C25.5 21.8855 25.0523 22.3333 24.5 22.3333H19.8334C19.2811 22.3333 18.8334 21.8855 18.8334 21.3333Z"
                                      fill="#AFC6FF"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M24.4593 4.50472C22.9412 4.33323 21.0154 4.33324 18.5634 4.33325H14.4366C11.9846 4.33324 10.0589 4.33323 8.54079 4.50472C6.99125 4.67975 5.7347 5.04474 4.69021 5.86962C4.3775 6.11657 4.08758 6.38933 3.824 6.68497C2.93577 7.68126 2.53912 8.88884 2.35019 10.3704C2.16665 11.8096 2.16667 13.6309 2.16669 15.9296V16.0702C2.16667 18.3689 2.16665 20.1902 2.35019 21.6294C2.53911 23.111 2.93575 24.3185 3.82395 25.3148C4.08767 25.6106 4.3776 25.8833 4.69016 26.1301C5.73466 26.9551 6.99123 27.3201 8.54079 27.4951C10.0589 27.6666 11.9846 27.6666 14.4366 27.6666H18.5634C21.0154 27.6666 22.9412 27.6666 24.4593 27.4951C26.0088 27.3201 27.2654 26.9551 28.3098 26.1301C28.6224 25.8833 28.9123 25.6107 29.1761 25.3148C30.0643 24.3185 30.4609 23.111 30.6499 21.6294C30.8334 20.1902 30.8334 18.3689 30.8334 16.0703V15.9296C30.8334 13.6309 30.8334 11.8096 30.6499 10.3704C30.4609 8.88884 30.0643 7.68127 29.176 6.68498C28.9125 6.38936 28.6225 6.11654 28.3097 5.86959C27.2653 5.04473 26.0088 4.67975 24.4593 4.50472ZM8.76529 6.49208C7.39089 6.64733 6.55814 6.94292 5.92974 7.43919C5.70731 7.61485 5.50229 7.80792 5.31684 8.01593C4.80134 8.59414 4.49613 9.35297 4.33412 10.6234C4.31857 10.7453 4.30446 10.8708 4.29167 10.9999H28.7084C28.6956 10.8707 28.6815 10.7453 28.6659 10.6234C28.5039 9.35297 28.1987 8.59413 27.6832 8.01592C27.4977 7.80792 27.2927 7.61488 27.0703 7.43923C26.442 6.94298 25.6092 6.64733 24.2348 6.49208C22.842 6.33475 21.0292 6.33325 18.5 6.33325H14.5C11.9708 6.33325 10.1581 6.33475 8.76529 6.49208ZM4.16669 15.9999C4.16669 18.3847 4.16859 20.0784 4.33412 21.3765C4.49612 22.6469 4.80134 23.4057 5.31685 23.9839C5.50218 24.1918 5.70719 24.3848 5.92978 24.5606C6.55817 25.0569 7.39092 25.3525 8.76529 25.5078C10.1581 25.6651 11.9708 25.6666 14.5 25.6666H18.5C21.0292 25.6666 22.842 25.6651 24.2348 25.5078C25.6092 25.3525 26.4419 25.0569 27.0702 24.5606C27.2928 24.3848 27.4978 24.1918 27.6832 23.9839C28.1987 23.4057 28.5039 22.6469 28.6659 21.3765C28.8314 20.0784 28.8334 18.3847 28.8334 15.9999C28.8334 14.8504 28.8329 13.8614 28.8139 12.9999H4.18613C4.16713 13.8614 4.16669 14.8504 4.16669 15.9999Z"
                                      fill="#AFC6FF"/>
                            </svg>
                        </template>
                        <template #title><h4 class="label__large"> {{
                                method.alias || tokens.newDesign.creditDebit
                            }} </h4></template>
                        <template #desc><p class="body__extrasmall"> MasterCard, Visa, {{
                                ['finquickly', 'tradreview', 'stockmtks', 'gitld', 'tradersclub', 'attrading', 'freedness'].includes(brand) ? 'Mir, SBP' : 'AMEX, Discover'
                            }} 💳 </p></template>
                    </BaseTabBox>
                    <BaseTabBox v-else-if="method.name === 'bank'" :tab="method.name"
                                :class="{ active: active.key === method.name }" @click.native="changeTab(method.name)">
                        <template #icon>
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 28 26"
                                 fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M13.8333 0C12.9292 0 12.0981 0.232608 11.1786 0.632797C10.2868 1.02088 9.25276 1.59427 7.95211 2.31547L7.91114 2.33819L2.81448 5.1642C2.09956 5.56062 1.50124 6.0585 1.09021 6.72983C0.677128 7.40451 0.500199 8.17749 0.500199 9.0447L0.5001 9.12637C0.499524 9.44205 0.498943 9.76226 0.575316 10.0487C0.767511 10.7695 1.2255 11.2341 1.78643 11.4831C2.1871 11.661 2.61522 11.7182 2.98078 11.7343V19.689C1.50552 20.4659 0.500199 22.0103 0.500199 23.7886C0.500199 24.6416 1.19428 25.3333 2.05056 25.3333H25.6161C26.4723 25.3333 27.1665 24.6417 27.1665 23.7886C27.1665 22.0103 26.1612 20.4659 24.6859 19.6889V11.7342C25.0514 11.7182 25.4795 11.661 25.8802 11.4831C26.4411 11.2341 26.8992 10.7694 27.0914 10.0486C27.1677 9.76218 27.1671 9.44205 27.1666 9.12635L27.1665 9.0447C27.1665 8.17749 26.9895 7.40451 26.5765 6.72984C26.1654 6.05852 25.5671 5.56062 24.8522 5.1642L19.7146 2.31553C18.4139 1.59431 17.3798 1.0209 16.4881 0.632798C15.5685 0.232608 14.7375 0 13.8333 0ZM11.9233 2.33148C11.1231 2.67973 10.1665 3.20899 8.81583 3.95792L3.71918 6.78394C3.19598 7.07404 2.87609 7.37237 2.67845 7.69518C2.48285 8.01464 2.36064 8.43371 2.36064 9.0447C2.36064 9.25346 2.36086 9.37933 2.36518 9.47431C2.3683 9.54294 2.37278 9.56921 2.3737 9.57395C2.39814 9.66496 2.42744 9.70478 2.44277 9.72223C2.45918 9.74092 2.48687 9.76472 2.54356 9.78988C2.67967 9.8503 2.90452 9.88618 3.25275 9.88618H24.4139C24.7621 9.88618 24.987 9.85031 25.1231 9.78988C25.1798 9.76471 25.2075 9.74092 25.2239 9.72223C25.2393 9.70478 25.2685 9.665 25.293 9.57407C25.2939 9.56934 25.2984 9.54306 25.3015 9.47433C25.3058 9.37934 25.306 9.25345 25.306 9.0447C25.306 8.43373 25.1838 8.01465 24.9882 7.69518C24.7906 7.37237 24.4707 7.07404 23.9475 6.78394L18.8508 3.95792C17.5001 3.20899 16.5436 2.67973 15.7434 2.33148C14.9616 1.99126 14.3931 1.85366 13.8333 1.85366C13.2736 1.85366 12.705 1.99126 11.9233 2.33148ZM2.37767 23.4797H25.289C25.1348 22.0894 23.9519 21.0081 22.5154 21.0081H5.15129C3.71486 21.0081 2.53191 22.0894 2.37767 23.4797ZM4.84122 19.1646C4.94371 19.1579 5.0471 19.1545 5.15129 19.1545H7.94195V11.7398H4.84122V19.1646ZM9.80239 19.1545H17.8643V11.7398H9.80239V19.1545ZM19.7247 19.1545H22.5154C22.6196 19.1545 22.723 19.1579 22.8254 19.1646V11.7398H19.7247V19.1545Z"
                                      fill="#7E7F8F"/>
                            </svg>
                        </template>
                        <template #title><h4 class="label__large"> {{
                                method.alias || tokens.newDesign.bankWithdrawal
                            }} </h4></template>
                        <template #desc><p class="body__extrasmall"> {{ tokens.newDesign.bankSubtitle }} </p></template>
                    </BaseTabBox>
                    <BaseTabBox v-else :tab="method.name" :class="{ active: active.key === method.name }"
                                @click.native="changeTab(method.name)">
                        <template #icon>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32"
                                 fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M3.67737 19.2851C4.16191 17.4133 5.81703 16 7.83331 16C10.1107 16 11.8212 17.7989 12.0942 19.8655C13.6832 20.3068 14.8333 21.8006 14.8333 23.5333C14.8333 25.5974 13.2108 27.3333 11.1333 27.3333H4.83331C2.59021 27.3333 0.833313 25.4581 0.833313 23.2222C0.833313 21.3872 2.01351 19.7989 3.67737 19.2851ZM5.54215 20.2079C5.64721 18.9405 6.66178 18 7.83331 18C9.15655 18 10.2449 19.2515 10.1236 20.6468C10.0993 20.926 10.1934 21.2026 10.3828 21.4092C10.5722 21.6158 10.8396 21.7334 11.1198 21.7334C12.0312 21.7334 12.8333 22.5112 12.8333 23.5333C12.8333 24.562 12.0383 25.3333 11.1333 25.3333H4.83331C3.76271 25.3333 2.83331 24.4227 2.83331 23.2222C2.83331 22.0943 3.65784 21.2177 4.64378 21.1204C5.12427 21.073 5.50226 20.689 5.54215 20.2079Z"
                                      fill="#AFC6FF"/>
                                <path
                                    d="M5.43585 7.2692C6.00013 6.70492 6.773 6.3667 8.11444 6.18635C9.48466 6.00212 11.2909 6 13.8333 6H20.4769C21.1229 6 21.5565 6.00056 21.892 6.02385C22.2184 6.0465 22.3771 6.08714 22.4815 6.13124C22.8816 6.30013 23.1999 6.61845 23.3687 7.01832C23.4128 7.12279 23.4535 7.28157 23.4761 7.60794C23.4843 7.72631 23.4897 7.85688 23.4933 8.00467C22.9828 8 22.4337 8 21.8454 8H13.8333C13.281 8 12.8333 8.44772 12.8333 9C12.8333 9.55229 13.281 10 13.8333 10H21.8333C22.8567 10 23.7214 10.0001 24.4699 10.0226C26.5561 10.0855 27.4072 10.3312 27.9546 10.8787C28.3236 11.2477 28.5642 11.7658 28.6958 12.7442C28.8312 13.7513 28.8333 15.0861 28.8333 17V18.3333C28.8333 20.2472 28.8312 21.582 28.6958 22.5891C28.5642 23.5675 28.3236 24.0856 27.9546 24.4546C27.5856 24.8237 27.0675 25.0643 26.0891 25.1958C25.082 25.3312 23.7472 25.3333 21.8333 25.3333H17.8333C17.281 25.3333 16.8333 25.781 16.8333 26.3333C16.8333 26.8856 17.281 27.3333 17.8333 27.3333H21.9065C23.7299 27.3334 25.1997 27.3334 26.3556 27.178C27.5558 27.0166 28.5663 26.6714 29.3688 25.8688C30.1714 25.0663 30.5166 24.0558 30.6779 22.8556C30.8334 21.6997 30.8333 20.2299 30.8333 18.4065V16.9268C30.8333 15.1034 30.8334 13.6336 30.6779 12.4777C30.5166 11.2775 30.1714 10.267 29.3688 9.46447C28.3945 8.49014 27.0991 8.18042 25.495 8.06918C25.491 7.8512 25.484 7.65156 25.4713 7.46947C25.4415 7.03943 25.3771 6.63342 25.2113 6.24056C24.8398 5.36049 24.1394 4.66024 23.2595 4.28873C22.8666 4.12285 22.4605 4.05849 22.0305 4.02865C21.6174 3.99998 21.1141 3.99999 20.5112 4L13.7581 4C11.3077 3.99998 9.3669 3.99996 7.84795 4.20418C6.28472 4.41435 5.01945 4.85718 4.02163 5.85499C3.10905 6.76758 2.6107 7.63554 2.37679 8.97599C2.16653 10.1809 2.16658 11.806 2.16664 14.2049L2.16665 14.3333C2.16665 14.8856 2.61436 15.3333 3.16665 15.3333C3.71893 15.3333 4.16665 14.8856 4.16665 14.3333C4.16665 11.7746 4.17049 10.3315 4.34702 9.31978C4.50364 8.42222 4.78634 7.91872 5.43585 7.2692Z"
                                    fill="#AFC6FF"/>
                            </svg>
                        </template>
                        <template #title><h4 class="label__large"> {{
                                method.alias || (method.name === 'zelle' ? tokens.fullScreenWithdrawal[method.name] : tokens.newDesign[method.name])
                            }} </h4></template>
                        <template #desc><p class="body__extrasmall"> {{
                                method.name === 'zelle' ? tokens.newDesign.zelleSubtitle : tokens.newDesign.cryptoSubtitle
                            }} </p></template>
                    </BaseTabBox>
                </div>
            </template>
        </BaseTabsBox>
        <BaseTabViewerItem :component="active.component" :data="active.key"/>
        <WithdrawalRequests/>
        <WithdrawalCertificates v-if="showWithdrawalCertificates"/>
    </div>
</template>

<script>
import BasePageTitle from "@/new-design/shared/ui/titles/BasePageTitle.vue"
import BaseTabBox from "@/new-design/shared/ui/tabs/BaseTabBox.vue"
import CreditDebitTab from "@/new-design/pages/withdrawal/tabs/CreditDebitTab.vue"
import CryptoTab from "@/new-design/pages/withdrawal/tabs/CryptoTab.vue"
import BankTab from "@/new-design/pages/withdrawal/tabs/BankTab.vue"
import ZelleTab from "@/new-design/pages/withdrawal/tabs/ZelleTab.vue"
import BaseTabViewerItem from "@/new-design/shared/ui/tabs/BaseTabViewerItem.vue"
import WithdrawalRequests from "@/new-design/entities/Withdrawal/ui/WithdrawalRequests.vue"
import BaseTabsBox from "@/new-design/shared/ui/tabs/BaseTabsBox.vue"
import {mapGetters} from "vuex"
import {DEFAULT_WITHDRAWAL_METHOD, BRAND, SHOW_WITHDRAWAL_CERTIFICATES} from "@/common/config"
import {withdrawalMethods} from "@/common/helpers"
import WithdrawalCertificates from "@/new-design/shared/ui/banners/WithdrawalCertificates.vue"

export default {
    name: "WithdrawalPage",
    components: {BaseTabsBox, WithdrawalCertificates, WithdrawalRequests, BaseTabViewerItem, BaseTabBox, BasePageTitle},
    data() {
        return {
            activeTab: {
                key: '',
                component: {}
            },
            allComponents: {
                card: CreditDebitTab,
                bank: BankTab,
                zelle: ZelleTab,
                crypto: CryptoTab,
            },
            defaultWithdrawalMethod: DEFAULT_WITHDRAWAL_METHOD,
            showWithdrawalCertificates: SHOW_WITHDRAWAL_CERTIFICATES,
            brand: BRAND
        }
    },
    computed: {
        ...mapGetters(['tokens', 'withdrawalList', 'user']),
        availableWithdrawalMethods() {
            const methods = []

            if (this.user.enable_withdrawal) {
                const { defaultMethods, cryptoMethods } = withdrawalMethods()
                const cryptoMethodNames = cryptoMethods.map(item => item.name.toLowerCase())

                let hasCryptoMethods = false

                this.withdrawalList.forEach(item => {
                    if (defaultMethods.includes(item.name)) {
                        methods.push(item)
                    } else if (cryptoMethodNames.includes(item.name) && !hasCryptoMethods) {
                        methods.push({
                            ...item,
                            name: 'crypto'
                        })

                        hasCryptoMethods = true
                    }
                })

                if (this.defaultWithdrawalMethod) {
                    const index = methods.findIndex(item => item.name === this.defaultWithdrawalMethod)

                    if (index !== -1) {
                        const item = methods.splice(index, 1)[0]
                        methods.unshift(item)
                    }
                }
            }

            return methods
        },
        active: {
            get() {
                if (this.activeTab.key) {
                    return this.activeTab
                }

                const method = this.availableWithdrawalMethods[0]

                return {
                    key: method.name,
                    component: this.allComponents[method.name],
                }
            },
            set(value) {
                this.activeTab = value
            }
        },
    },
    methods: {
        changeTab(tab) {
            const method = this.availableWithdrawalMethods.find(item => item.name === tab)

            if (!method) {
                return
            }

            switch (method.name) {
                case 'bank':
                    this.active = {
                        key: method.name,
                        component: BankTab,
                    }
                    break

                case 'card':
                    this.active = {
                        key: method.name,
                        component: CreditDebitTab,
                    }
                    break

                case 'zelle':
                    this.active = {
                        key: method.name,
                        component: ZelleTab,
                    }
                    break

                case 'crypto':
                    this.active = {
                        key: method.name,
                        component: CryptoTab,
                    }
                    break
            }
        }
    }
}
</script>

<style scoped>
.desc {
    color: var(--System-OnSurfaceVariant);
    font-weight: 500;
    padding-bottom: 12px;
}

.tab {
    flex: 1 1 auto;
}
</style>
